<template>
	<div style="height: 84vh;">
		<ListingButton :lists="lists" @add='add' @disable='disable' @recovery='recovery' @delete='BatchDelete'>
		</ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@SwitchStatus="SwitchStatus" style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		couponspecies_list,
		couponspecies_hard_delete,
		couponspecies_switch
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'kinds',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '禁用',
					type: 'warning',
					icon: 'el-icon-remove-outline',
					funt: 'disable'
				}, {
					name: '恢复',
					type: 'success',
					icon: 'el-icon-refresh-right',
					funt: 'recovery'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'delete'
				}, ],
				tableData: [],
				table_label: [{
					label: ' ID',
					value: 'id'
				}, {
					label: '优惠券名称',
					value: 'name'
				}, {
					label: '描述',
					value: 'describe'
				}, {
					label: '金额',
					value: 'amount'
				}, {
					label: '发放数量',
					value: 'num'
				}, {
					label: '创建时间',
					value: 'create_time'
				}, {
					label: '结束时间',
					value: 'end_time'
				}, {
					label: '状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15
				}
			}
		},
		methods: {
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				couponspecies_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加优惠券种类'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '优惠券种类编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				couponspecies_hard_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				couponspecies_hard_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			// 状态更改
			SwitchStatus(value) {
				const {
					id,
					status
				} = value
				console.log('id:', id, 'status', status);
				couponspecies_switch({
					ids: [`${id}`],
					status: `${status}`
				}).then(res => {
					this.Messages(res)
					if (res.status != 200) {
						couponspecies_list(this.data).then(res => {
							console.log('res', res);
							if (res.status == 200) {
								this.tableData = res.data.list
								this.total = res.data.count
							}
						})
					}
				})
			},
			//批量禁用
			disable() {
				couponspecies_switch({
					ids: this.multipleSelection,
					status: '0'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			//批量启用
			recovery() {
				couponspecies_switch({
					ids: this.multipleSelection,
					status: '1'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>

</style>